import { useState } from "react";

export default function useExpandableRows() {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleExpand = (id) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const isExpanded = (id) => expandedRows.has(id);

  return { expandedRows, toggleExpand, isExpanded };
}